<template>
  <div class="home">
    <a-result status="404" title="404" sub-title="Sorry, the page you visited does not exist.">
      <template #extra>
        <a-button type="primary" @click="$router.push({path:'/'})">
          Back Home
        </a-button>
      </template>
    </a-result>
  </div>
</template>
<script>
  export default {
    name: 'home',
    components: {
      
    },
    data(){
      return {

      }
    },
    mounted(){
     
    },
    methods : {
     

    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

</style>